import React, { ReactElement } from 'react';

const DEFAULT_ICON_SIZE = 80;

type Props = {
  className?: string;
};

const BigHeartIcon = ({ className }: Props): ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={DEFAULT_ICON_SIZE}
      height={DEFAULT_ICON_SIZE}
      viewBox="0 0 80 80"
      className={className}
    >
      <g fill="none" fillRule="evenodd" transform="translate(.44)">
        <path d="M0 0h80v80H0z" />
        <circle cx="24.62" cy="31.57" r="19.12" fill="#E8E8E8" fillRule="nonzero" />
        <path
          stroke="#212121"
          strokeLinecap="round"
          strokeWidth="2"
          d="M55.39 52.54c3.9-4.07 7.41-8.07 9-10.76 4.59-7.66 1.5-20.6-7.93-22.87-8.09-2-14.39 5.51-16.09 8.63-.75 1.36-.75 1.36-1.49 0-1.71-3.12-8-10.59-16.09-8.63-9.44 2.27-12.53 15.21-7.94 22.87C18.96 48.65 35.58 64.15 39 67.31a.92.92 0 001.24 0c.85-.78 2.52-2.34 4.61-4.33m3.39-3.31l2.13-2.11M5.13 25.3l3.62-.37m-4.53-7.38l5.85 3.36m2.7-3.01l-1.49-3.28M74.15 25.3l-3.62-.37m4.53-7.38l-5.85 3.36M66.5 17.9l1.5-3.28"
        />
      </g>
    </svg>
  );
};

BigHeartIcon.ICON_SIZE = DEFAULT_ICON_SIZE;

export default BigHeartIcon;
